import { createAsyncThunk } from '@reduxjs/toolkit';
import profileService from './profile-service';
import { toast } from 'react-toastify';

export const getProfile = createAsyncThunk(
  'profile/getProfile',
  async (thunkAPI) => {
    try {
      const delivered = await profileService.getProfile();

      return delivered;
    } catch (e) {
      toast(e?.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditAdminProfile = createAsyncThunk(
  'profile/edit_profile_admin',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileService.editAdmin(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditAdminPassword = createAsyncThunk(
  'profile/edit_admin_password',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileService.editAdminPassword(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      console.log('Error', e);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const EditAdminProfilePic = createAsyncThunk(
  'profile/edit_profile_pic_admin',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await profileService.editAdminProfilePic(requestData);

      return delivered;
    } catch (e) {
      toast(e?.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);
